import _ from 'lodash'
import {api} from '../api';
import {WAREHOUSE_LIST_FETCHED, 
    WAREHOUSE_MODEL_UPDATED_BY_FORM,
    EXISTING_WAREHOUSE_UPDATED,
    NEW_WAREHOUSE_CREATED,
    WAREHOUSE_MODEL_UPDATED_ON_SERVER,
    WAREHOUSE_MODEL_LOADED,
    INTEGRATION_LOGS_LIST_FETCHED
} from './types';

export const fetchIntegrationLogs = (id, jwt, params) => (dispatch) => {
    return api.integrations.fetchLog(jwt, params, id).then(res => {
        dispatch({
            type: INTEGRATION_LOGS_LIST_FETCHED,
            payload: res.data.data
        })
        return res;
    }).catch(err => {
        throw err
    })
}

export const updateWarehouseModelInStore = (field, value) => {
    return ({
        type: WAREHOUSE_MODEL_UPDATED_BY_FORM,
        payload: {field, value}
    })
}

export const fetchWarehouses = (jwt,params) => (dispatch) => {
    return api.warehouse.fetch(jwt, params).then(res => {
        dispatch({
            type: WAREHOUSE_LIST_FETCHED,
            payload: res.data.data
        })
        return res;
    }).catch( err => {
        throw err
    })
}
export const loadWarehouseById = (jwt, id) => (dispatch) => {
    if (_.isInteger(parseInt(id))) {
        return api.warehouse.loadModel(jwt, id).then( res => {
            dispatch({
                type: WAREHOUSE_MODEL_LOADED,
                payload: res.data.data
            })
        }).catch( err => {
            throw err
        })
    } else {
        dispatch({
            type: WAREHOUSE_MODEL_LOADED,
            payload: {
                id: null,
                label: '',
                stock: true,
                status: 'Active',
                name: '',
                contact: '',
                phone: '',
                email: '',
                street1: '',
                street2: '',
                city: '',
                state: '',
                postal: '',
                country: ''
            }
        })
    }
}

export const updateOrCreateWarehouse = (jwt, model) => (dispatch) => {
    if (model.id) {
        //PUT update
        return api.warehouse.update(jwt, model).then(res => {
            dispatch({
                type: EXISTING_WAREHOUSE_UPDATED,
                payload: {
                    key: model.id,
                    value: model.id,
                    text: model.label
                }
            })
            dispatch({
                type: WAREHOUSE_MODEL_UPDATED_ON_SERVER,
                payload: model
            })
        }).catch(err => {throw err});
    } else {
        //Create NEW, set store once updated
        return api.warehouse.create(jwt, model).then(res => {
            dispatch({
                type: WAREHOUSE_MODEL_LOADED,
                payload: res.data.data
            })
            dispatch({
                type: NEW_WAREHOUSE_CREATED,
                payload: {
                    key: res.data.data.id,
                    value: res.data.data.id,
                    text: res.data.data.label
                }
            })
            return res;
        }).catch(err => {throw err})
    }
}


// WEBPACK FOOTER //
// ./src/actions/setting.js